module.exports = __webpack_public_path__ + "img/v4_configCoinList.9bb1464e.png";